import * as THREE from 'three';

export class BaseDrawer {
	constructor(sceneManager, startStake, endStake, roadStakes) {
		this.sceneManager = sceneManager;
		this.geometry = new THREE.Geometry();
		this.geometry.ownerDrawer = this;
		this.mesh = new THREE.Object3D();
    	// this.sceneManager.scene.add(this.mesh);
		if (startStake == undefined) return;
		this.startStake = startStake;
		this.endStake = endStake;
		this.roadStakes = new Array();
		this.stakeInterval = roadStakes[1].stakeval - roadStakes[0].stakeval;
		this.lastStakeIndex = 1 + (this.endStake - roadStakes[0].stakeval) / this.stakeInterval //lastStakeIndex大于等于2，否则不能称作一段路
		this.startStakeIndex = (this.startStake - roadStakes[0].stakeval) / this.stakeInterval

		for (var i = 0; i < roadStakes.length; i++) {
			if (i >= this.startStakeIndex && i <= this.lastStakeIndex) {
				this.roadStakes.push(roadStakes[i]);
			}
		}

		var roadStakesLen = this.roadStakes.length;
		this.roadStakesLen = roadStakesLen;
		this.startStakeCenterPos = new THREE.Vector3(); //起点中央坐标
		var alpha1 = (startStake - this.roadStakes[0].stakeval) / this.stakeInterval;
		this.startStakeCenterPos.lerpVectors(this.roadStakes[0].baseCenter, this.roadStakes[1].baseCenter, alpha1);
		this.endStakeCenterPos = new THREE.Vector3(); //终点中央坐标
		var alpha2 = (endStake - this.roadStakes[roadStakesLen - 2].stakeval) / this.stakeInterval;

		this.endStakeCenterPos.lerpVectors(this.roadStakes[roadStakesLen - 2].baseCenter, this.roadStakes[roadStakesLen - 1].baseCenter, alpha2);
		this.leftBasePos = new THREE.Vector3(); //左基缘坐标
		this.leftBasePos.lerpVectors(this.roadStakes[0].a1, this.roadStakes[1].a1, alpha1);
		this.rightBasePos = new THREE.Vector3(); //右基缘坐标
		this.rightBasePos.lerpVectors(this.roadStakes[0].a2, this.roadStakes[1].a2, alpha1);

		this.leftEndBasePos = new THREE.Vector3(); //左基缘坐标
		this.leftEndBasePos.lerpVectors(this.roadStakes[roadStakesLen - 2].a1, this.roadStakes[roadStakesLen- 1].a1, alpha2);
		this.rightEndBasePos = new THREE.Vector3(); //右基缘坐标
		this.rightEndBasePos.lerpVectors(this.roadStakes[roadStakesLen - 2].a2, this.roadStakes[roadStakesLen - 1].a2, alpha2);
		this.roadWidth = this.rightBasePos.distanceTo(this.leftBasePos); //道路宽度
	}

	getDrawingPoints(lerpAlpha, laneNo, steps) {
		var pts = new Array();
		// var firstPt = new THREE.Vector3();
		// pts.push(firstPt.lerpVectors(this.roadStakes[0].a1, this.roadStakes[0].a2, lerpAlpha));
		for (var i= 0; i < this.roadStakes.length; i++){
			var pt = new THREE.Vector3();
			var item = this.roadStakes[i];
			pt.lerpVectors(item.a1, item.a2, lerpAlpha);
			if (i == 1){
				//在第二点之前插入一个点，以避免旋转shape
				//在curve中有个computeFrenetFrames，第0和第一个点的y差决定了shape的旋转角度，
				//导致了shape的旋转
				// https://stackoverflow.com/questions/25639268/three-js-extrudegeometry-using-depth-and-a-direction-vector
				//https://github.com/mrdoob/three.js/blob/master/src/extras/core/Curve.js
				var prevPt = pts[0];
				var midPt = new THREE.Vector3();
				midPt.lerpVectors(prevPt, pt, 0.05); 
				midPt.y = prevPt.y;
				pts.push(midPt);
			}
			pts.push(pt);
			item.roadElementParams[laneNo] = pt; //每条车道线的中心位置
		}
		// this.roadStakes.map(item => {
		// 	var pt = new THREE.Vector3();
		// 	pts.push(pt.lerpVectors(item.a1, item.a2, lerpAlpha));
		// 	item.roadElementParams[laneNo] = pt; //每条车道线的中心位置
		// });
		if(steps == undefined) return pts;
		var popPt = new THREE.CatmullRomCurve3(pts);

		return popPt.getPoints(steps*pts.length);
	}

	drawExtrudeShape(pathPts, shapePts, material) {

		var spline = new THREE.CatmullRomCurve3(pathPts);

		spline.curveType = 'catmullrom';
		spline.closed = false;
		
		var extrudeSettings = {
			steps: pathPts.length * 5,
			curveSegments:10000,
			bevelEnabled: false,
			extrudePath: spline
		};
		var shape = new THREE.Shape(shapePts);
		var targetGeometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
		var targetMesh = new THREE.Mesh(targetGeometry, material);
		targetMesh.updateMatrix();
		this.geometry.merge(targetMesh.geometry, targetMesh.matrix);
		return new THREE.Mesh(this.geometry, material);
	}

	doSelect(intersect, action){
		console.log("base", intersect, action);
	}
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/BaseDrawer.js